import styled, { css } from 'styled-components';

export interface ClickableButtonCSSProps {
  disabled?: boolean;
}

export const ClickableButtonCSS = css<ClickableButtonCSSProps>`
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  display: block;
  outline: none;
  padding: 0;

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `};
`;

/**
 * The part of `ClickableButtonCSS` that means anything on a non-button element, for a clickable
 * surface whose `<button>` is supplied further out — a `MenuButton` custom trigger, say. The rest of
 * `ClickableButtonCSS` is button user-agent resets, and `disabled` has no meaning here.
 */
export const ClickableSurfaceCSS = css`
  color: inherit;
  cursor: pointer;
`;

/**
 * Unstyled clickable button base. Use for:
 * - Styled extensions (e.g., custom list items)
 * - Invisible click targets
 * - Custom interactive elements
 *
 * For standard buttons with visual styling, use Button from 'components/ui/shared/Buttons/Button'
 */
export const Clickable = styled.button`
  ${ClickableButtonCSS}
`;

/**
 * Use this component for nested clickable areas to avoid React warning about nested buttons.
 * Note: This is a layout utility, not a standard button - keep using this for invisible click targets.
 */
export const FillWithClickable = styled(Clickable)`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
`;
